import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

const LinkWithHistory = ({ children, href, onClick = () => {}, ...props }) => {
    const history = useHistory();

    return (
        <a
            href={href}
            onClick={e => {
                onClick();

                // History is undefined if called from within a modal
                if (!history) {
                    return;
                }

                e.preventDefault();
                history.push(href);
            }}
            {...props}
        >
            {children}
        </a>
    );
};

LinkWithHistory.propTypes = {
    children: PropTypes.node.isRequired,
    href: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};

export default LinkWithHistory;
